import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  code: null, // string, optional  //Mã ngoại ngữ
  name: { //object, optional // Tên ngoại ngữ
    vi: null, // string, optional  // Tên tiếng Việt
    en: null, // string, optional  // Tên tiếng Anh
  },
  index: null //integer, optional // Thứ tự sắp xếp    
};

// validation form
model.validForm = {

  code: [ValidService.required],
  name: { //object, optional // Tên ngoại ngữ
    vi: [], // string, optional  // Tên tiếng Việt
    en: [], // string, optional  // Tên tiếng Anh
  },
  index: []
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100, 500],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "",
  defaultSort: ["loai", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      code: "",
      "name.vi": "",
      "name.en": ""
    },
    valid: {
      code: [],
      "name.vi": [],
      "name.en": []
    },
    operator: {
      code: ":regex_i:", //:regex:, $vn_text=Viêt nam
      "name.vi": ":regex_i:",
      "name.en": ":regex_i:"
    }
  }
};

export default model;